module.exports = __webpack_public_path__ + "img/zhantai.0e992e1e.png";